import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PogLogo from "@/components/PogLogo";

const NotFound = () => {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen bg-[#14100D] text-[#EFE7D6] flex flex-col"
      style={{ fontFamily: "Outfit, sans-serif" }}
    >
      <Helmet>
        <title>404 — Page Not Found | POG Spirits</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="The page you are looking for does not exist. Return to POG Spirits — Hawaiian vodka and spiked island punch, made in partnership with Meadow Gold."
        />
      </Helmet>

      <header className="px-6 py-8 flex justify-center border-b border-[#EFE7D6]/10">
        <Link to="/" aria-label="POG Spirits home" data-testid="not-found-logo-link">
          <PogLogo className="h-10 w-auto" />
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-2xl text-center">
          <p
            data-testid="not-found-code"
            className="text-[#F26B1F] tracking-[0.35em] text-xs uppercase mb-6"
          >
            Error 404
          </p>
          <h1
            className="text-5xl sm:text-6xl mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            This bottle isn't on the shelf.
          </h1>
          <p className="text-[#EFE7D6]/70 text-base sm:text-lg leading-relaxed mb-10">
            The page you were looking for has moved, sold out, or never existed.
            Let's get you back to the good stuff.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              data-testid="not-found-home-link"
              className="px-8 py-4 bg-[#F26B1F] text-[#14100D] text-sm tracking-[0.2em] uppercase font-semibold hover:bg-[#EFE7D6] transition-colors duration-300"
            >
              Back to Home
            </Link>
            <Link
              to="/journal"
              data-testid="not-found-journal-link"
              className="px-8 py-4 border border-[#EFE7D6]/30 text-sm tracking-[0.2em] uppercase hover:border-[#F26B1F] hover:text-[#F26B1F] transition-colors duration-300"
            >
              Read the Journal
            </Link>
          </div>
        </div>
      </main>

      <footer className="px-6 py-8 border-t border-[#EFE7D6]/10 text-center text-xs text-[#EFE7D6]/40 tracking-wider">
        POG Spirits · Please enjoy responsibly · 21+
      </footer>
    </div>
  );
};

export default NotFound;
